<style lang="sass" scoped>
@import '../../../../../css/core';

.reservations-table-time-ruler-body {
  .-row {
    position: relative;
  }

  .-tick-mark {
    position: absolute;
    border-left: solid $border-color-default;
  }

  .-tick-label {
    font-size: 12px;
    padding-left: 5px;
    font-weight: bold;
    position: relative;
    z-index: 100;
  }
}
</style>


<template>
<div class="reservations-table-time-ruler-body clearfix">
  <div class="-row" v-bind:style="rowStyle">
    <div
        v-for="tick in ticks"
        class="-cell"
        v-bind:style="cellStyleByTick(tick)"
        @mouseover="$dispatch('tick-over', tick)"
        @mouseout="$dispatch('tick-out', tick)"
    >
      <span class="-tick-mark" v-bind:style="tickMarkStyle(tick)"></span>
      <span v-if="tick.minutes() === 0" class="-tick-label">{{ tick.format("H:mm") }}</span>
    </div>
  </div>
</div>
</template>


<script>
import moment from 'moment'

export default {
  name: 'reservations-table-time-ruler-body',
  mixins: [require('../body.vue')],
  methods: {
    tickMarkStyle(tick) {
      let style = {
        'border-left-width': this.tickBorderWidth + 'px',
      }

      if (tick.minutes() === 0) {
        style.top = 0
        style.height = this.cellStyle.height
      } else if (tick.minutes() === 30) {
        style.top = `calc(${this.cellStyle.height} * 0.5)`
        style.height = `calc(${this.cellStyle.height} * 0.5)`
      } else {
        style.top = `calc(${this.cellStyle.height} * 0.75)`
        style.height = `calc(${this.cellStyle.height} * 0.25)`
      }

      return style
    },
    cellStyleByTick(tick) {
      let style = this._cellStyleByTick(tick)
      delete style['border-left-style']
      delete style['border-left-width']
      return style
    }
  },
}
</script>



// WEBPACK FOOTER //
// body.vue?061432a3